document.documentElement.classList.add('js');
window.addEventListener('DOMContentLoaded',()=>{
 const header=document.querySelector('[data-site-header]');
 const toggle=document.querySelector('.menu-toggle');
 const nav=document.querySelector('.site-nav');
 const onScroll=()=>header&&header.classList.toggle('is-scrolled',window.scrollY>20);
 onScroll(); window.addEventListener('scroll',onScroll,{passive:true});
 if(toggle&&nav){toggle.addEventListener('click',()=>{const open=nav.classList.toggle('open');toggle.setAttribute('aria-expanded',String(open));});nav.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>{nav.classList.remove('open');toggle.setAttribute('aria-expanded','false')}));}
 const items=document.querySelectorAll('.reveal');
 if('IntersectionObserver' in window&&!window.matchMedia('(prefers-reduced-motion: reduce)').matches){const obs=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('is-visible');obs.unobserve(e.target)}}),{threshold:.08});items.forEach(el=>obs.observe(el));}else{items.forEach(el=>el.classList.add('is-visible'));}
});

/* TY.DSGNS comparison sliders — global, editor-safe controller */
(() => {
  const updateComparison = (input) => {
    if (!(input instanceof HTMLInputElement) || input.type !== 'range') return;

    const numericValue = Number.parseFloat(input.value);
    const position = Number.isFinite(numericValue) ? Math.min(100, Math.max(0, numericValue)) : 50;
    input.setAttribute('aria-valuetext', `${position}%`);

    const workBlock = input.closest('[data-before-after]');
    if (workBlock) {
      workBlock.style.setProperty('--position', `${position}%`);
      return;
    }

    const caseBlock = input.closest('[data-case-compare]');
    if (caseBlock) {
      caseBlock.style.setProperty('--case-position', `${position}%`);
    }
  };

  const initializeComparisons = (root = document) => {
    root.querySelectorAll('[data-before-after] input[type="range"], [data-case-compare] input[type="range"]').forEach(updateComparison);
  };

  document.addEventListener('input', (event) => {
    if (event.target.matches?.('[data-before-after] input[type="range"], [data-case-compare] input[type="range"]')) {
      updateComparison(event.target);
    }
  });

  document.addEventListener('change', (event) => {
    if (event.target.matches?.('[data-before-after] input[type="range"], [data-case-compare] input[type="range"]')) {
      updateComparison(event.target);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeComparisons(document), { once: true });
  } else {
    initializeComparisons(document);
  }

  document.addEventListener('shopify:section:load', (event) => initializeComparisons(event.target));
  document.addEventListener('shopify:section:reorder', (event) => initializeComparisons(event.target));
  document.addEventListener('shopify:block:select', (event) => initializeComparisons(event.target.closest?.('section') || document));
})();
